import React, { Fragment } from 'react';
import { bool } from 'prop-types';
import { grayDarker, sansSerif } from 'styles/css-constants';
import { SITE_NAME } from 'constants/site';

// prettier-ignore
export const DEFAULT_AFFILIATE_DISCLAIMER = 'We independently select these products&mdash;if you buy from one of our links, we may earn a commission.';
// prettier-ignore
export const ALT_AFFILIATE_DISCLAIMER = `${SITE_NAME} may earn commission or other compensation from this content.`;
function AffiliateMessage({ shouldShowAltDisclaimer }) {
  const AFFILIATE_DISCLAIMER = shouldShowAltDisclaimer
    ? ALT_AFFILIATE_DISCLAIMER
    : DEFAULT_AFFILIATE_DISCLAIMER;
  return (
    <Fragment>
      <div
        className="AffiliateMessage"
        dangerouslySetInnerHTML={{ __html: AFFILIATE_DISCLAIMER }}
      />
      <style jsx>{`
        .AffiliateMessage {
          color: ${grayDarker};
          font-family: ${sansSerif};
          font-size: var(--fontScaleNeg1);
          font-style: italic;
          line-height: 1.3;
        }
      `}</style>
    </Fragment>
  );
}

AffiliateMessage.propTypes = {
  shouldShowAltDisclaimer: bool
};

AffiliateMessage.defaultProps = {
  shouldShowAltDisclaimer: false
};

export default AffiliateMessage;
